import type { Strain } from '@shared';
import {
  createLocalCatalogueImportProvenance,
  type StrainWithLocalImport,
} from './provenance';

/**
 * Map a server catalogue Strain into a new local record payload.
 * - New local `id` is assigned by the local repository.
 * - Images are not copied (no local blob storage in this slice).
 * - `lastSyncedAt` cleared — import is not ongoing sync.
 * - `sourceType` set to `imported` (existing shared enum).
 */
export function mapServerStrainToLocalImport(source: Strain): Strain &
  StrainWithLocalImport {
  const now = new Date().toISOString();
  return {
    id: '', // replaced by local repository before persist
    productId: source.productId,
    name: source.name,
    productName: source.productName,
    producer: source.producer,
    brand: source.brand,
    category: source.category,
    cultivarType: source.cultivarType,
    lineageSourceText: source.lineageSourceText,
    strainClassSourceText: source.strainClassSourceText,
    thcPercent: source.thcPercent,
    cbdPercent: source.cbdPercent,
    cbnPercent: source.cbnPercent,
    cbgPercent: source.cbgPercent,
    thcvPercent: source.thcvPercent,
    cbcPercent: source.cbcPercent,
    totalTerpenesPercent: source.totalTerpenesPercent,
    packageDate: source.packageDate,
    purchaseDate: source.purchaseDate,
    lotNumber: source.lotNumber,
    sourceType: 'imported',
    notes: source.notes,
    referenceNotes: source.referenceNotes,
    isVerified: source.isVerified,
    isArchived: source.isArchived,
    isBalancingStrain: source.isBalancingStrain,
    saveStatus: 'complete',
    lastSyncedAt: null,
    createdAt: now,
    updatedAt: now,
    images: [],
    primaryImage: null,
    localCatalogueImport: createLocalCatalogueImportProvenance({
      id: source.id,
      productId: source.productId,
      importedAt: now,
    }),
  };
}
